export default __webpack_public_path__ + "static/media/medium.b2db761c.svg";